/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { isRouteOpsStrategy, RouteOpsStrategy } from 'types/modules/routing/Strategy'

// Not the effective value: window > env > redux > tenant gate > default is merged in `routeOpsStrategyOverride.ts`.

interface PersistentRouteOpsStrategyState {
  // `null` is "never chose", which unlike choosing v1-bulk defers to the tenant gate.
  strategy: RouteOpsStrategy | null
}

const initialState: PersistentRouteOpsStrategyState = {
  strategy: null,
}

export const PERSISTENT_ROUTE_OPS_STRATEGY_KEY = 'persistentRouteOpsStrategy' as const

const persistentRouteOpsStrategySlice = createSlice({
  name: PERSISTENT_ROUTE_OPS_STRATEGY_KEY,
  initialState,
  reducers: {
    setRouteOpsStrategy: (state, action: PayloadAction<RouteOpsStrategy>) => {
      state.strategy = action.payload
    },
    resetRouteOpsStrategy: () => initialState,
  },
})

export const { setRouteOpsStrategy, resetRouteOpsStrategy } = persistentRouteOpsStrategySlice.actions

/**
 * Minimum shape the selector reads from the root store — kept narrow so
 * tests can construct a fixture without standing up the full RootState.
 */
export interface RouteOpsStrategyRootStateSlice {
  [PERSISTENT_ROUTE_OPS_STRATEGY_KEY]?: PersistentRouteOpsStrategyState
}

// The chosen id, or undefined. One persisted by an older release outlives the union, so it reads as unchosen.
export const selectPersistedRouteOpsStrategy = (state: RouteOpsStrategyRootStateSlice): RouteOpsStrategy | undefined => {
  const persisted = state?.[PERSISTENT_ROUTE_OPS_STRATEGY_KEY]?.strategy
  return isRouteOpsStrategy(persisted) ? persisted : undefined
}

export { initialState as persistentRouteOpsStrategyInitialState }

export default persistentRouteOpsStrategySlice.reducer
